import { faCheckCircle, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import BlueButton from 'components/inputs/BlueButton'
import React, { useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import './MainPage.css'

interface IShowPrice {
  show: boolean
  price: number
  message?: string
}

interface ISuccessPaymentNotificationProps {
  showPrice: IShowPrice
  onClose: () => void
}

const SuccessPaymentNotification: React.FC<ISuccessPaymentNotificationProps> = ({
  showPrice,
  onClose,
}) => {
  useEffect(() => {
    if (showPrice.show) {
      setTimeout(() => {
        onClose()
      }, 4000)
    }
  }, [showPrice, onClose])

  return (
    <Modal show={showPrice.show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Ваш заказ обрабатывается</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {showPrice.message ? (
          showPrice.message
        ) : (
          <div className='d-flex justify-content-center align-items-center col-gap-5'>
            {showPrice.message ? (
              <FontAwesomeIcon icon={faTimes} color='var(--color-red)' size='2x' />
            ) : (
              <FontAwesomeIcon
                icon={faCheckCircle}
                color='var(--color-success)'
                size='2x'
              />
            )}
            <>Платеж принят, сумма {showPrice.price}&nbsp;₽</>
          </div>
        )}
        <br />
        Уважаемый клиент! Ваше обращение принято в работу.
        <br />С Вами свяжется менеджер в течение часа согласно графика:
        <br /> Пн-Пт с 09:00 до 19:00
        <br />
        <strong>ВАЖНО!</strong>
        <br /> Ваш заказ будет отменен через <strong>семь дней</strong>, если его не
        забрать.
      </Modal.Body>
      <Modal.Footer>
        <BlueButton onClick={onClose}>Понятно</BlueButton>
      </Modal.Footer>
    </Modal>
    // <div
    //   style={{
    //     display: showPrice.show ? 'flex' : 'none',
    //     justifyContent: 'center',
    //     width: '100%',
    //     position: 'fixed',
    //     top: '10px',
    //     zIndex: 30,
    //   }}
    // >
    //   <Toast show={showPrice.show} onClose={onClose}>
    //     <Toast.Header style={{ padding: '16px' }}>
    //       {showPrice.message ? (
    //         <FontAwesomeIcon icon={faTimes} color='var(--color-red)' size='2x' />
    //       ) : (
    //         <FontAwesomeIcon
    //           icon={faCheckCircle}
    //           color='var(--color-success)'
    //           size='2x'
    //         />
    //       )}

    //       <strong className='me-auto' style={{ marginLeft: '1rem', color: 'black' }}>
    //         Платеж
    //       </strong>
    //     </Toast.Header>
    //     <Toast.Body>
    //       {showPrice.message ? (
    //         showPrice.message
    //       ) : (
    //         <>Успешно, сумма {showPrice.price}&nbsp;₽</>
    //       )}
    //     </Toast.Body>
    //   </Toast>
    // </div>
  )
}
export default SuccessPaymentNotification

export type { IShowPrice }
